import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#004488',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        mainGrey: '#8CA3A9',
        lightGrey: '#BAC2C3',
        mainBlue: '#212840',
        darkGrey: '#353135',
        headerBlue: '#37405B',
        lightBlue: '#67BED3',
        mainGreen: '#73DCAC',
        mainTurquoise: '#6ED3EA',
        mainRed: '#EC3D3D',
        grey: '#F2F2F2',
        mainOrange: '#E0BF10',
        lightBlack: '#171E37',
        borderGrey: '#E2E5E6',
      },
    },
  },
});
